import { ActionsUnion, createAction } from "store/helper";

import { ITeamCreatePayload, ITeamDeletePayload, ITeamUpdatePayload } from "./interfaces";

export enum TeamsViewActionsNames {
  CREATE_TEAM = "VIEWS/ACTIONS/CREATE_TEAM",
  UPDATE_TEAM = "VIEWS/ACTIONS/UDPATE_TEAM",
  DELETE_TEAM = "VIEWS/ACTIONS/DELETE_TEAM",
  SET_SELECTED_TEAM = "VIEWS/TEAMS/SET_SELECTED_TEAM",
  SET_FOCUSED_COLUMN = "VIEWS/TEAMS/SET_FOCUSED_COLUMN",
  SET_LIST_SORTING = "VIEWS/ACTIONS/SET_LIST_SORTING",
}

export const TeamsViewActions = {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  createTeam: (payload: ITeamCreatePayload) => createAction(TeamsViewActionsNames.CREATE_TEAM, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  updateTeam: (payload: ITeamUpdatePayload) => createAction(TeamsViewActionsNames.UPDATE_TEAM, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  deleteTeam: (payload: ITeamDeletePayload) => createAction(TeamsViewActionsNames.DELETE_TEAM, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setSelectedTeam: (payload: { selectedTeamId: string }) =>
    createAction(TeamsViewActionsNames.SET_SELECTED_TEAM, payload),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setFocusedColumn: (focusedColumn: number) =>
    createAction(TeamsViewActionsNames.SET_FOCUSED_COLUMN, { focusedColumn }),
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  setListSorting: (payload: { field: string; desc: boolean }) =>
    createAction(TeamsViewActionsNames.SET_LIST_SORTING, payload),
};

export type TeamsViewAction = ActionsUnion<typeof TeamsViewActions>;
